import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function money(n) {
  return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
}

function createSurangHub() {
  return {
    loading: true,
    products: [],
    projects: [],
    config: {},
    isCreator: false,
    tab: 'products',
    search: '',

    get filteredProducts() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.products;
      return this.products.filter((p) => {
        const name = String(p.name || '').toLowerCase();
        const cat = String(p.category?.name || '').toLowerCase();
        return name.includes(q) || cat.includes(q);
      });
    },

    get filteredProjects() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.projects;
      return this.projects.filter((pr) => {
        const title = String(pr.title || '').toLowerCase();
        const product = String(pr.product?.name || '').toLowerCase();
        return title.includes(q) || product.includes(q);
      });
    },

    async init() {
      if (!Alpine.store('auth')?.isLoggedIn) {
        window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
        return;
      }
      await Promise.all([this.loadProducts(), this.loadProjects()]);
      this.loading = false;
    },

    async loadProducts() {
      try {
        const { data } = await axios.get('/api/v1/surang/products');
        this.products = data.data?.products || [];
        this.config = data.data?.config || {};
        this.isCreator = !!this.config.is_creator;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat produk SURANG.', 'error');
      }
    },

    async loadProjects() {
      try {
        const { data } = await axios.get('/api/v1/surang/projects');
        this.projects = data.data || [];
      } catch { /* silent */ }
    },

    money,
    startUrl(p) {
      return `/surang/start/${p.id}`;
    },
    editorUrl(pr) {
      return `/surang/editor/${pr.id}`;
    },
  };
}

Alpine.data('surangHub', createSurangHub);
